// extracted by mini-css-extract-plugin
module.exports = {"info":"MainScreen_info__S2wOV","btn-container":"MainScreen_btn-container__2-EG9","close":"MainScreen_close__3BS4e","active":"MainScreen_active__1qr0-"};